import { useLayoutEffect, useState } from "react";

export const useBoardOverlayFrame = ({
  boardRef,
  overlayRef,
  viewportRef,
  syncKey,
}) => {
  const [frame, setFrame] = useState({
    left: 0,
    top: 0,
    width: 0,
    height: 0,
    overlayWidth: 0,
    overlayHeight: 0,
  });

  useLayoutEffect(() => {
    const sync = () => {
      const board = boardRef.current;
      const overlay = overlayRef.current;
      if (!board || !overlay) return;
      const boardRect = board.getBoundingClientRect();
      const overlayRect = overlay.getBoundingClientRect();
      setFrame({
        left: boardRect.left - overlayRect.left,
        top: boardRect.top - overlayRect.top,
        width: boardRect.width,
        height: boardRect.height,
        overlayWidth: overlayRect.width,
        overlayHeight: overlayRect.height,
      });
    };
    sync();
    const viewport = viewportRef.current;
    viewport?.addEventListener("scroll", sync, { passive: true });
    const observer =
      typeof ResizeObserver === "undefined" ? null : new ResizeObserver(sync);
    if (overlayRef.current) observer?.observe(overlayRef.current);
    if (boardRef.current) observer?.observe(boardRef.current);
    window.addEventListener("resize", sync);
    return () => {
      viewport?.removeEventListener("scroll", sync);
      observer?.disconnect();
      window.removeEventListener("resize", sync);
    };
  }, [boardRef, overlayRef, syncKey, viewportRef]);

  return frame;
};
